export default __webpack_public_path__ + "static/media/slide22.9438ea23.jpg";